import { Divider, Spinner, Flex } from "@chakra-ui/react";
import React from "react";
import { useQueryGetUser } from "../../../store/useQueryGetUser";
import {
  SectionHeader,
  SectionContainer,
  SettingsStack,
} from "../components/SettingsComponents";
import { BillingOwnerDetails } from "./BillingOwnerDetails";
import { SubscriptionDetails } from "./SubscriptionDetails";
import { useAccountSubscriptionData } from "./useAccountSubscriptionData";

export function AccountSubscriptionSettings() {
  const {
    subscription,
    account,
    plans,
    downgradePlan,
    redirecting,
    setRedirecting,
    isLoading,
    hasError,
  } = useAccountSubscriptionData();

  const getUser = useQueryGetUser();

  const loading = isLoading || !account || !plans || hasError || !getUser.data;

  return (
    <SectionContainer>
      <SectionHeader
        title="Subscription"
        description="Manage your subscription."
      />
      {loading ?
        <Flex justifyContent="center" my="40px">
          <Spinner />
        </Flex>
      : <SettingsStack>
          <SubscriptionDetails
            subscription={subscription}
            downgradePlan={downgradePlan}
            isRedirecting={redirecting}
            setIsRedirecting={setRedirecting}
            user={getUser.data}
          />
          <Divider />
          <BillingOwnerDetails />
        </SettingsStack>
      }
    </SectionContainer>
  );
}
